import React, { Component } from 'react';
import axios from 'axios';
import { adpatedGameTimeUser } from '../../utils/api-adpters';
import MatchPage from './match-page';
import { adaptMatchFromWebsocket } from '../../utils/websocket-adapters';

class MainMatchPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gameInfo: {},
      isLoading: true,
    };
    this._isMounted = false;
    this.getAcademiaGameImformation(this.props.match.params.id.toString())
    this.updateLiveGameInfo = this.updateLiveGameInfo.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      this.getAcademiaGameImformation(this.props.match.params.id.toString());
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  updateLiveGameInfo(game) {
    const newStateGameInfo = adaptMatchFromWebsocket(this.state.gameInfo, game);
    if (this._isMounted) {
      this.setState({
        gameInfo: newStateGameInfo,
      })
    }
  }

  getInstanceAcademia = () =>
    axios.create({
      baseURL: 'https://www.academiadasapostas.com',
    });

  getAcademiaGameImformation(matchId) {
    const request = this.getInstanceAcademia()({
      method: 'get',
      url: `/api/?mode=web&jsonrpc={"jsonrpc":"2.0","method":"match_details","params":["${matchId}"],"id":1}`
    });
    return request
      .then(response => {
        let gamesByDay = adpatedGameTimeUser(response.data.result);
        this.setState({
          isLoading: false,
          gameInfo: gamesByDay,
        });
        document.title = [gamesByDay.team_A_name] + ' ' + [gamesByDay.fs_A] + ' vs ' + [gamesByDay.fs_B] + ' ' + [gamesByDay.team_B_name] + ' | ' + [gamesByDay.competition_name] + ' | ' + [gamesByDay.date_utc] + ' ' + [gamesByDay.time_utc.substring(0, 5)] + ' • Placardabola';
      });
  }

  render() {
    return (
      (typeof this.state.gameInfo !== "undefined" && Object.keys(this.state.gameInfo).length > 0 && !this.state.isLoading) ? (
        <MatchPage
          gameInfo={this.state.gameInfo}
          handleLivescores={this.updateLiveGameInfo}
        />
      ) : (
        <div className="global">
          <div className="is-loading">
            <div className="loader"></div>
          </div>
        </div>
      )
    );
  }
}
export default MainMatchPage;